module.exports = __webpack_public_path__ + "RishabPullancheri-713854bc.webp";